import deepClone from "../../foundation/js/deepClone"

const isLoggedIn = function() {

    const includesList = ['#isloggedin-customer', '#isloggedin-salesperson']

    const userLoggedInStatus = includesList.reduce((result, id) => {
        return !result ? !!document.querySelector(id) : result
    }, false)

    document.documentElement.classList.add(userLoggedInStatus ? "logged-in" : "logged-out")

    return userLoggedInStatus

}

const showRrp = function() {
    return document.querySelector('html').getAttribute("showrrp") != 'false'
}

const showPriceToggle = function() {
    return document.querySelector('html').getAttribute("showpricetoggle") === 'true'
}

export default {
    namespaced: true,
    state: {
        lang: {
            isoCode: document.documentElement.lang,
            displayValue: null
        },
        ambience_toggle: false,
        mega_menu_data: undefined,
        active_mega_menu: undefined,
        overlay_visible: false,
        mega_menu_timer: undefined,
        mobile_drawer_component: undefined,
        service_menu_links: undefined,
        country_selector_data: undefined,
        scraped_linkspot_data: undefined,
        scraped_about_us_data: undefined,
        carousel_config: undefined,
        onresize_callbacks: [],
        display_table_data_for_client_list: undefined,
        original_table_data_for_client_list: undefined,
        client_list_take: 20,
        client_list_accumulated_take: 0,
        search_menu_open: false,
        search_page_url: '',
        global_error_modal_visibility_state: false,
        user_logged_in_status: isLoggedIn(),
        overlay_callback_on_remove: undefined,
        page_filters: undefined,
        show_rrp: showRrp(),
        show_price_toggle: showPriceToggle()
    },
    mutations: {
        set_page_filters(state, filters) {
            state.page_filters = filters
        },
        set_currently_selected_lang(state, status) {
            state.lang.displayValue = status
        },
        set_user_logged_in_status(state, status) {
            state.user_logged_in_status = status
        },
        set_search_page_url(state, url) {
            state.search_page_url = url
        },
        open_search_menu(state) {
            state.search_menu_open = true
        },
        close_search_menu(state) {
            state.search_menu_open = false
        },
        set_ambience_toggle(state, value) {
            state.ambience_toggle = value === 'true' ? true : false
        },
        append_onresize_callback(state, callback) {
            state.onresize_callbacks.push(callback)
        },
        set_mega_menu_data(state, data) {
            state.mega_menu_data = data
        },
        set_active_mega_menu(state, menuId) {
            state.active_mega_menu = menuId
        },
        show_overlay(state, config) {
            state.overlay_visible = true
            state.overlay_callback_on_remove = config && config.callback ? config.callback : null
        },
        hide_overlay(state) {
            state.overlay_visible = false
        },
        set_mega_menu_timer(state, timer) {
            state.mega_menu_timer = timer
        },
        set_mobile_drawer_component(state, componentName) {
            state.mobile_drawer_component = componentName
        },
        set_mobile_drawer_component(state, componentName) {
            state.mobile_drawer_component = componentName
        },
        set_service_menu_links(state, data) {
            state.service_menu_links = data
        },
        set_country_selector_data(state, data) {
            state.country_selector_data = data
        },
        set_global_error_modal_visibility_state(state, payload) {
            state.global_error_modal_visibility_state = payload
        },
        set_display_table_data_for_client_list(state, data) {
            data.entries = data.entries.slice(0, state.client_list_accumulated_take)
            state.display_table_data_for_client_list = data
        },
        set_original_table_data_for_client_list(state, data) {
            state.original_table_data_for_client_list = data
        },
        set_client_list_accumulated_take(state, payload) {
            state.client_list_accumulated_take = payload
        }
    },
    actions: {
        showMoreClients(context) {
            const newAccValue = context.state.client_list_accumulated_take + context.state.client_list_take
            const originalData = deepClone(context.state.original_table_data_for_client_list)
            context.commit('set_client_list_accumulated_take', newAccValue)
            context.commit('set_display_table_data_for_client_list', originalData)
        },
        windowOnresize(context, callback) {
            window.onresize = null
            context.commit('append_onresize_callback', callback)
            window.onresize = () => {
                context.state.onresize_callbacks.forEach(callback => callback())
            }

        },
        closeMegaMenu(context) {
            let megaMenuTimer = context.state.mega_menu_timer
            clearTimeout(megaMenuTimer)
            megaMenuTimer = setTimeout(() => {
                context.commit('set_active_mega_menu', null)
                context.commit('close_search_menu')
                context.commit('hide_overlay')
            }, 500)
            context.commit('set_mega_menu_timer', megaMenuTimer)
        },
        restartMegaMenuTimer(context) {
            context.dispatch('closeMegaMenu')
        },
        cancelMegaMenuTimer(context) {
            let megaMenuTimer = context.state.mega_menu_timer
            clearTimeout(megaMenuTimer)
        },
        setClientListTableData(context, tableData) {
            context.commit('set_client_list_accumulated_take', context.state.client_list_take)
            context.commit('set_original_table_data_for_client_list', deepClone(tableData))
            context.commit('set_display_table_data_for_client_list', deepClone(tableData))
        },
        searchClientList(context, searchInput) {
            const searchValue = searchInput.value.toLowerCase()
            context.commit('set_display_table_data_for_client_list', deepClone(context.state.original_table_data_for_client_list))

            if (searchValue.length > 1) {

                const searchResultMatchingCountry = context.state.original_table_data_for_client_list.entries.filter(item => {
                    return item.country.toLowerCase().includes(searchValue)
                })

                const searchResultMatchingCustomer = context.state.original_table_data_for_client_list.entries.filter(item => {
                    return item.customer.toLowerCase().includes(searchValue)
                })

                const matchingEntriesWithoutDuplicates = [...new Set([...searchResultMatchingCountry, ...searchResultMatchingCustomer])]
                const tableData = deepClone(context.state.display_table_data_for_client_list)

                tableData.entries = matchingEntriesWithoutDuplicates
                context.commit('set_display_table_data_for_client_list', tableData)
            }
        }
    },
    getters: {
        getMegaMenuData(state) {
            return state.mega_menu_data[state.active_mega_menu]
        },
        getMenuForMobile(state) {
            const megaMenuData = deepClone(state.mega_menu_data)
            for (let group in megaMenuData) {
                if (!megaMenuData[group].megaMenu) continue
                megaMenuData[group].megaMenu = megaMenuData[group].megaMenu.map(menu => {
                    const menuGroupHeader = menu.find((item, itemIndex) => {
                        return !!(itemIndex < 1)
                    })

                    const subLevel = menu.filter((item, itemIndex) => {
                        return !!(itemIndex > 0)
                    })

                    return [
                        menuGroupHeader,
                        subLevel
                    ]
                })

            }
            return megaMenuData
        }
    }
}